import { fromPairs, isEmpty } from "lodash-es";

import { getAccessToken } from "../services/auth";
import { SELECTED_CUSTOMER_ID } from "./sessionStorage";

const AUTHORIZATION_KEY = "Authorization";
const LEVRO_ORG_KEY = "Levro-Org-ID";

export const NO_LEVRO_ORG_KEY_HEADERS_INIT: Record<typeof LEVRO_ORG_KEY, string> = { [LEVRO_ORG_KEY]: "" };

export async function getRequestHeaders(
    headersInit?: HeadersInit,
    noAuthorization?: boolean,
): Promise<{ [key: string]: string }> {
    const headers = new Headers(headersInit);

    if (!headers.has(AUTHORIZATION_KEY) && !noAuthorization) {
        const token = await getAccessToken();
        headers.set(AUTHORIZATION_KEY, `Bearer ${token}`);
    }

    if (!headers.has(LEVRO_ORG_KEY) && !noAuthorization) {
        const selectedCustomerId = (() => {
            try {
                const maybeSelectedCustomerId = sessionStorage.getItem(SELECTED_CUSTOMER_ID);
                if (maybeSelectedCustomerId != null) {
                    return JSON.parse(maybeSelectedCustomerId);
                }
                return "";
            } catch {
                return "";
            }
        })();

        headers.set(LEVRO_ORG_KEY, selectedCustomerId);
    }

    headers.forEach((value, key, parent) => {
        // empty header values are invalid, so we remove
        if (isEmpty(value)) {
            parent.delete(key);
        }
    });

    // convert to a map because `Headers` does not work in the fetch options despite the typings
    return fromPairs(Array.from(headers.entries()));
}
